import React from 'react';
import { Flex, Radio, Typography } from 'antd';

import { formTypes } from '../utils/fields';
import {
    PROMOCODE_FORM_TYPE,
    PromocodeFormType,
} from '../service/promocodes.interface';
import { setPromocodeFormType } from '../store/promocode.slice';
import { useAppDispatch } from '../../../../../store';

export const PromocodeFormTypeSwitcher = ({ onChangeType }) => {
    const dispatch = useAppDispatch();

    const changeFormType = (type: PromocodeFormType) => {
        dispatch(setPromocodeFormType(type));
        onChangeType();
    };

    return (
        <Flex vertical gap={8}>
            <Typography.Text>Выберите тип промокода</Typography.Text>
            <Radio.Group
                onChange={({ target }) => changeFormType(target.value)}
                options={formTypes}
                defaultValue={PROMOCODE_FORM_TYPE.UNIQUE}
            />
        </Flex>
    );
};
